<div class="mt-4">
  <label class="mb-0 position-relative live-stream-switch">{{'labels.live_stream_mode'|translate}}</label>
  <ui-switch
    color="#556ee6" [checked]="isLiveStreamModeActive" (change)="toggleLiveStreamMode()" uncheckedLabel=""
    checkedLabel=""
    size="small"
    class="ms-1 me-1"></ui-switch>
</div>
